module.exports = __webpack_public_path__ + "static/img/new.47c53c00.png";